import { useEffect, useState } from 'react';
import { fetchPersonalization } from '../lib/api';
import type { Personalization } from '../types/personalization';

export type PersonalizationState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'success'; data: Personalization }
  | { status: 'error'; error: Error };

export function usePersonalization(trackingId: string | null): PersonalizationState {
  const [state, setState] = useState<PersonalizationState>(
    trackingId ? { status: 'loading' } : { status: 'idle' },
  );

  useEffect(() => {
    if (!trackingId) {
      setState({ status: 'idle' });
      return;
    }

    const controller = new AbortController();
    setState({ status: 'loading' });

    fetchPersonalization(trackingId, controller.signal)
      .then((data) => {
        if (!controller.signal.aborted) {
          setState({ status: 'success', data });
        }
      })
      .catch((err: unknown) => {
        if (controller.signal.aborted) return;
        const error = err instanceof Error ? err : new Error(String(err));
        setState({ status: 'error', error });
      });

    return () => controller.abort();
  }, [trackingId]);

  return state;
}
